import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CentraCheckoutScript from '@activebrands/core-web/components/CentraCheckoutScript';
import Events from '@activebrands/core-web/libs/Events';
import { CheckoutEvents } from '@activebrands/core-web/libs/Events/types';
import { selectPaymentMethod } from '@activebrands/core-web/state/basket/actions';
import { logger } from '@activebrands/core-web/utils/logger';

const CheckoutContainer = ({ defaultPaymentMethod, children }) => {
    const dispatch = useDispatch();

    const basket = useSelector(state => state.basket);
    const { id, paymentMethods, paymentMethodId, items, currency, totalDiscount, shippingMethodId } = basket;

    const getPaymentMethod = () => {
        let paymentMethod = null;

        if (defaultPaymentMethod) {
            if (Array.isArray(defaultPaymentMethod)) {
                defaultPaymentMethod.forEach(method => {
                    const foundMatch = paymentMethods.find(p => p.id.includes(method));
                    if (!paymentMethod && foundMatch) {
                        paymentMethod = foundMatch;
                    }
                });
            } else {
                paymentMethod = paymentMethods.find(p => p.id.includes(defaultPaymentMethod));
            }
        } else {
            logger.error('Missing defaultPaymentMethod.');
        }
        return paymentMethod;
    };

    useEffect(() => {
        Events.trigger(CheckoutEvents.SHIPPING, { shippingTier: shippingMethodId });

        if (id && !paymentMethodId) {
            const paymentMethod = getPaymentMethod();
            if (paymentMethod) {
                dispatch(selectPaymentMethod(paymentMethod.id));
            }
        }

        if (paymentMethodId) {
            Events.trigger(CheckoutEvents.PAYMENT, { option: paymentMethodId });
        }
    }, []);

    return (
        <>
            <CentraCheckoutScript />
            {children}
        </>
    );
};

CheckoutContainer.propTypes = {
    children: PropTypes.node,
    defaultPaymentMethod: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
};

export default CheckoutContainer;
